import _ from 'underscore'
export default {
bind: (el, { arg, value = {} }) => {
if (!arg) {
throw new Error('no event name provided, for example: v-debounce:click')
}
console.log("debounce");
const time = value ? Number(value) : 500
let flag = true
const debounceClickFn = _.debounce(() => (flag = true), time, true)
el._arg = event => {
flag = false;
event.disabled = true;
//console.log("before delay: " + new Date());
debounceClickFn();
//console.log("after delay: " + new Date());
if (!flag) {
    //console.log("stopImmediate");
    //alert("You may click button multiple time, please wait few seconds to try again!");
event && event.stopImmediatePropagation()
}
}
el.addEventListener(arg, el._arg, true)
},
unbind: (el, { arg }) => {
    //console.log("unbind from debounce");
el.removeEventListener(arg, el._arg)
delete el._arg
},
}